










import Vue from 'vue'

import { ReportFilterItem } from '@/types/service-response';
import ReportingTree from '@/components/reporting/ReportingTree.vue'
import ReportingFilter from '@/components/reporting/ReportingFilter.vue'
import AddressReportingTree from '@/components/master-data/address/AddressReportingTree.vue'
import AddressReportingFilter from '@/components/master-data/address/AddressReportingFilter.vue'

interface ComponentData {
  reportItem: Array<ReportFilterItem>
  componentKey: number
  reportLayout: string
  reportName: string
  selectedReportList: any[]
}

export default Vue.extend({
  name: 'AddressReports',

  components: {
    ReportingTree,
    ReportingFilter,
    AddressReportingTree,
    AddressReportingFilter
  },

  props: {
    addressId:{
      type: Number,
      default: undefined
    }
  },

  data (): ComponentData {
    return {
      reportItem: [],
      componentKey: 0,
      reportLayout: '',
      reportName: '',
      selectedReportList: []
    }
  },
  computed: {
    selectedClass (): number {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 3
      } else {
        return 1
      }
    }
  },

  methods: {
    selectedReport(payload: {reportItem: Array<ReportFilterItem>, reportLayout: string, reportName: string}[]): void {
      this.selectedReportList = payload
    },
  }
    
})
